import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const SocialX: FC<IconSvgProps> = ({ color='#000000', clss, width, height }) => {
    return (
        <svg className={clss} viewBox="0 0 300 271" width={width} height={height}>
            <g fill={color}>
                <path
                    d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"
                />
            </g>
        </svg>
    );
};

export default SocialX;
